"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortOption = exports.SortEnum = void 0;
var SortEnum;
(function (SortEnum) {
    SortEnum[SortEnum["BestMatch"] = 99] = "BestMatch";
    SortEnum[SortEnum["Newest"] = 1] = "Newest";
    SortEnum[SortEnum["Oldest"] = 9] = "Oldest";
    SortEnum[SortEnum["DateUpdate"] = 5] = "DateUpdate";
    SortEnum[SortEnum["Popular"] = 2] = "Popular";
    SortEnum[SortEnum["MakeModel"] = 3] = "MakeModel";
    SortEnum[SortEnum["Year"] = 4] = "Year";
    SortEnum[SortEnum["Mileage"] = 7] = "Mileage";
    SortEnum[SortEnum["Mpg"] = 8] = "Mpg";
    SortEnum[SortEnum["Distance"] = 10] = "Distance";
    SortEnum[SortEnum["Rating"] = 11] = "Rating";
    SortEnum[SortEnum["YearNewest"] = 20] = "YearNewest";
    SortEnum[SortEnum["YearOldest"] = 21] = "YearOldest";
    SortEnum[SortEnum["PriceLowHigh"] = 30] = "PriceLowHigh";
    SortEnum[SortEnum["PriceHighLow"] = 31] = "PriceHighLow";
    SortEnum[SortEnum["MileageLowHigh"] = 40] = "MileageLowHigh";
    SortEnum[SortEnum["MileageHighLow"] = 41] = "MileageHighLow";
})(SortEnum || (exports.SortEnum = SortEnum = {}));
exports.sortOption = [
    {
        id: SortEnum.BestMatch,
        name: 'Best Match',
        sort: {
            _score: -1,
            date_create: 'desc',
        },
        esSort: [{ _score: 'desc' }, { date_create: 'desc' }],
    },
    {
        id: SortEnum.Newest,
        name: 'Date Listed (Newest first)',
        sort: { date_create: -1 },
        esSort: [{ date_create: 'desc' }],
    },
    {
        id: SortEnum.Oldest,
        name: 'Date Listed (Oldest First)',
        sort: { date_create: 1, _id: 1 },
        esSort: [{ date_create: 'asc' }],
    },
    {
        id: SortEnum.MakeModel,
        name: 'Make, Model',
        sort: { make: 1, model: 1, date_create: -1 },
        esSort: [{ 'make.keyword': 'asc' }, { 'model.keyword': 'asc' }, { date_create: 'desc' }],
    },
    {
        id: SortEnum.YearNewest,
        name: 'Year (Newest first)',
        sort: { year: -1, mileage: 1, price_sort_lh: 1, date_create: -1 },
        esSort: [{ year: 'desc' }, { mileage: 'asc' }, { price_sort_lh: 'asc' }, { date_create: 'desc' }],
    },
    {
        id: SortEnum.YearOldest,
        name: 'Year (Oldest first)',
        sort: { year: 1, mileage: 1, price_sort_lh: 1, date_create: -1 },
        esSort: [{ year: 'asc' }, { date_create: 'desc' }, { mileage: 'asc' }, { price_sort_lh: 'asc' }],
    },
    {
        id: SortEnum.PriceLowHigh,
        name: 'Price (Lowest first)',
        sort: { price_sort_lh: 1, year: -1, date_create: -1 },
        esSort: [{ price_sort_lh: 'asc' }, { date_create: 'desc' }],
    },
    {
        id: SortEnum.PriceHighLow,
        name: 'Price (Highest first)',
        sort: { price_sort_hl: -1, date_create: -1 },
        esSort: [{ price_sort_hl: 'desc' }, { date_create: 'desc' }],
    },
    {
        id: SortEnum.MileageLowHigh,
        name: 'Mileage (Lowest first)',
        sort: { mileage: 1, date_create: 'desc' },
        esSort: [{ mileage_sort_lh: 'asc' }, { date_create: 'desc' }],
    },
    {
        id: SortEnum.Mpg,
        name: 'MPG',
        sort: { mpg_max: -1, date_create: 'desc' },
        esSort: [{ mpg_max: 'desc' }, { date_create: 'desc' }],
    },
];
